module.exports = __webpack_public_path__ + "img/jacqueline_davidson.d8207da2.png";